import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/Footer.css";
import profilePDF from "../assets/images/company/Innothrust.pdf";
import logo from "../assets/images/logo.svg";

const Footer = () => {
  return (
    <>
      {/* Footer */}
      <footer className="footer" id="footer">
        <div className="footer-main">
          <div className="container">
            <div className="row gy-4">
              {/* About */}
              <div className="col-lg-4 col-md-12 footer-widget footer-about">
                <div className="footer-logo">
                  <Link to="/">
                    <img
                      src={logo}
                      alt="Innothurst"
                      className=" footer-logo-img"
                    />
                  </Link>
                </div>

                <p className="footer-desc">
                  To support our companies, we have focused expertise in areas
                  including recruiting and human resources; branding and
                  communications; business development; scaling IT
                  infrastructure; and growth and leadership.
                </p>
              </div>

              {/* Right side columns */}
              <div className="col-lg-6 col-md-12">
                <div className="row gy-4">
                  {/* Quick Links */}
                  <div className="col-lg-6 col-md-6 footer-widget footer-widget-1">
                    <h3 className="widget-title">Quick Link</h3>

                    <ul className="list-dash">
                      <li>
                        <a
                          href={profilePDF}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Organization Profile
                        </a>
                      </li>

                      <li>
                        <Link to="/about-us">About Us</Link>
                      </li>

                    

                      <li>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                    </ul>
                  </div>

                  {/* Policy */}
                  <div className="col-lg-6 col-md-6 footer-widget footer-widget-2">
                    <h3 className="widget-title">Policy Links</h3>

                    <ul className="list-dash">
                      <li>
                        <Link to="/terms-of-use">Terms of Use</Link>
                      </li>

                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="copyright-info text-center text-lg-start">
                  <span>Copyright © 2026 Innothurst. All Rights Reserved.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
